import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-4xl">
          <div className="text-center max-w-2xl mx-auto">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              关于地址与安装的疑问
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里整理了用户最常遇到的疑问，点击问题即可展开查看解答。
            </p>
          </div>

          <div className="mt-10 space-y-3">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={item.q}
                  className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200/60 pt-4">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}